module.exports = __webpack_public_path__ + "static/sarahatregister-ca8dd1ae2e7449e199040a87571eb3f1.jpg";